module.exports = require("./ff-Latn-MR.js");